import { Accordion, AccordionDetails, AccordionSummary, Box, Chip, Divider, Typography } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useDispatch, useSelector } from "react-redux";
import { insuranceActions, insuranceSelector } from "../../model";

interface Props {}

export const InsuranceAccordion = ({}: Props) => {
  const dispatch = useDispatch();

  const accordionConfig = useSelector(insuranceSelector.accordionConfig);

  return (
    <Box>
      {accordionConfig.map((config, idx) => {
        const { header, disabled, expanded, detailsComponent: DetailsComponent } = config;
        return (
          <Accordion
            key={header}
            disabled={disabled}
            expanded={expanded}
            disableGutters
            onChange={() => dispatch(insuranceActions.updateAccordionConfig({ idx, config: { expanded: !expanded } }))}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls={`${header}-content`}
              id={`${header}-header`}>
              <Chip
                label={<Typography fontSize="small">{idx + 1}</Typography>}
                color={disabled ? "default" : "primary"}
                size="small"
              />
              <Typography ml={1} fontWeight="500">
                {header}
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Divider />
              <DetailsComponent />
              <Divider />
            </AccordionDetails>
          </Accordion>
        );
      })}
    </Box>
  );
};
